<template>
	<nav aria-label="Page navigation">
		<ul class="pagination">
			<li class="page-item">
				<button class="page-link" type="button" aria-label="Previous"
					@click="onClickPreviousPage"
					:disabled="isInFirstPage"
				>
					<span aria-hidden="true"><i class="page-nav bi-chevron-left"></i></span>
				</button>
			</li>

			<!-- <li class="page-item">
				<button class="page-link" type="button" aria-label="Previous"
					@click="onClickFirstPage"
					:disabled="isInFirstPage"
				>
					<span aria-hidden="true">1</span>
				</button>
			</li> -->

			<li v-for="(page, index) in pages" class="page-item" :class="{ active: isPageActive(page.name) }" :key="index">
				<button class="page-link" type="button"
					@click="onClickPage(page.name)"
					:disabled="page.isDisabled"
					:aria-label="`Go to page number ${page.name}`"
				>
					{{ page.name }}
				</button>
			</li>

			<!-- <li class="page-item">
				<button class="page-link" type="button" aria-label="Next"
					@click="onClickLastPage"
					:disabled="isInLastPage"
				>
					<span aria-hidden="true">{{ totalPages }}</i></span>
				</button>
			</li> -->

			<li class="page-item">
				<button class="page-link" type="button" aria-label="Next"
					@click="onClickNextPage"
					:disabled="isInLastPage"
				>
					<span aria-hidden="true"><i class="page-nav bi bi-chevron-right"></i></span>
				</button>
			</li>
		</ul>
	</nav>
</template>
<script>
export default {
	name: 'Pagination',
	props: {
		maxVisibleButtons: {
			type: Number,
			required: false,
			default: 3,
		},
		totalPages: {
			type: Number,
			required: true,
		},
		total: {
			type: Number,
			required: true,
		},
		perPage: {
			type: Number,
			required: true,
		},
		currentPage: {
			type: Number,
			required: true,
		},
	},
	computed: {
		startPage() {
			let startPage = 1;

			if (this.currentPage === 1) {
				startPage = 1;
			} else if ((this.currentPage + this.maxVisibleButtons - 1) > this.totalPages || this.currentPage === this.totalPages) {
				startPage = this.totalPages - this.maxVisibleButtons + 1;
			} else {
				startPage = this.currentPage - 1;
			}

			return startPage;
		},
		endPage() {
			return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
		},
		pages() {
			const range = [];

			for (let i = this.startPage; i <= this.endPage; i += 1) {
				range.push({
					name: i,
					isDisabled: i === this.currentPage,
				});
			}

			return range;
		},
		isInFirstPage() {
			return this.currentPage === 1;
		},
		isInLastPage() {
			return this.currentPage === this.totalPages;
		},
	},
	methods: {
		onClickFirstPage() {
			this.$emit('pagechanged', 1);
			this.scrollToTop();
		},
		onClickPreviousPage() {
			this.$emit('pagechanged', this.currentPage - 1);
			this.scrollToTop();
		},
		onClickPage(page) {
			this.$emit('pagechanged', page);
			this.scrollToTop();
		},
		onClickNextPage() {
			this.$emit('pagechanged', this.currentPage + 1);
			this.scrollToTop();
		},
		onClickLastPage() {
			this.$emit('pagechanged', this.totalPages);
			this.scrollToTop();
		},
		isPageActive(page) {
			return this.currentPage === page;
		},
		scrollToTop() {
			// Menggunakan smooth scroll untuk efek yang lebih baik
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
	},
};
</script>
<style lang="scss" scoped>
	.pagination {
		.page-item {
			.page-link {
				border: none;
				background-color: transparent;
				color: #4D4D4D;
				padding: 0.2rem 0.75rem;
			}

			&.active {
				border-bottom: 1.5px solid $primary_color;
				.page-link {
					color: $primary_color;
				}
			}

			.page-nav {
				font-size: 13px;
			}

			:disabled {
				.page-nav {
					color: #b3b3b3;
				}
			}
		}
	}
</style>
